import React from 'react';
import { ReactiveJsonRoot } from '@ea-lab/reactive-json';

/**
 * CrmShell — monte la vraie coquille Orbit (sidebar/header data-driven via
 * Navigation.yaml), puis le contenu. La Topbar vitrée + la recherche ⌘K ont été
 * retirées (jugées redondantes) ; à la place, un en-tête de contenu sobre porte
 * le titre, le sous-titre, un badge optionnel (ex. « Béta ») et des actions. Les
 * vues détail appellent CrmShell SANS `title` → aucun en-tête (elles ont le leur).
 * Le décalage du contenu (mode sidebar) est géré par le CSS du shell (padding de
 * #orbit_front_app), donc le contenu n'a rien de spécial à faire.
 */
export function CrmShell({ plugins, title, subtitle, badge, actions, children }) {
  return (
    <>
      <ReactiveJsonRoot
        rjBuildUrl="/components/layout/Navigation.yaml"
        rjBuildFetchMethod="GET"
        plugins={plugins}
      />
      <div className="min-h-screen bg-[color:var(--surface-page)] font-sans">
        <main className="max-w-[88rem] mx-auto px-4 sm:px-7 py-6">
          {title && (
            <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
              <div className="min-w-0">
                <div className="flex items-center gap-2.5">
                  <h1 className="font-display text-2xl font-bold tracking-tight text-slate-900 truncate">{title}</h1>
                  {badge}
                </div>
                {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
              </div>
              {actions}
            </div>
          )}
          {children}
        </main>
      </div>
    </>
  );
}

export default CrmShell;
